/* ============================================================
   Savings calculator — page.kalkulacka.liquid
   Product data synchronised with sections/calculator.liquid;
   ESG metrics per final_web_kalkulacka.html (source ADEME 2022).
   ============================================================ */

const tscalcData = {
  notebook: {
    p1: 413,
    p2: 1213.63,
    p1name: 'HP EliteBook 840 G8',
    p2name: 'HP EliteBook 8 G1i',
    p1sub: 'i5-1145G7 · 16GB DDR4 · 512GB SSD · 14"<br>2-year warranty',
    p2sub: 'Core Ultra 5 225H · 16GB DDR5 · 512GB SSD · 14"',
    p1img: 'https://cdn.shopify.com/s/files/1/0703/7190/1665/files/hp_elitebook_840_G6_-_techsavers.jpg?v=1726130630',
    p2img: 'https://cdn.shopify.com/s/files/1/0703/7190/1665/files/HP-EliteBook-8-G1-14_0b.jpg?v=1776421018',
    p1url: '/products/hp-elitebook-840-g8-core-i5-1145g7-26ghz16gb-ram512gb-m2-ssdbatterycare-310056',
    p2url: 'https://www.techoutlet.eu/en/hp-elitebook-8-g1i-14-u5-225u-16gb-512gb-ir-w11p-backlit-fp-sensor-ad3s4et-abh.html',
    label1: 'laptop',
    label234: 'laptops',
    label5: 'laptops',
    note: 'In this calculator we compare a brand-new laptop with a refurbished device a few generations older. For everyday office work it still has more than enough performance.',
    co2rep: 18.5,
    co2new: 167.5,
    water: 186300,
    mat: 655.1,
    waste: 1.585,
    specs: {
      refurb: [
        ['Processor', 'Intel Core i5-1145G7 2.6 GHz'],
        ['Memory',    '16 GB DDR4'],
        ['Display',   '14" IPS 1920×1080'],
        ['Storage',   '512 GB M.2 SSD'],
        ['Warranty',  '2 years']
      ],
      neww: [
        ['Processor', 'Intel Core Ultra 5 225H'],
        ['Memory',    '16 GB DDR5'],
        ['Display',   '14" IPS 1920×1200'],
        ['Storage',   '512 GB M.2 SSD NVMe'],
        ['Warranty',  '2 years']
      ]
    }
  },
  pc: {
    p1: 446,
    p2: 981.86,
    p1name: 'HP EliteDesk 800 G6 DM',
    p2name: 'HP EliteDesk 8 Mini G1i',
    p1sub: 'i5-10500T · 16GB DDR4 · 512GB SSD PCIe<br>2-year warranty',
    p2sub: 'Core Ultra 5 235T · 16GB DDR5 · 512GB SSD NVMe',
    p1img: 'https://cdn.shopify.com/s/files/1/0703/7190/1665/files/HP_EliteDesk_800_G5_DM.jpg?v=1726130949',
    p2img: 'https://cdn.shopify.com/s/files/1/0703/7190/1665/files/HP-EliteDesk-8-Mini-G1i_0b.jpg?v=1776421025',
    p1url: '/products/hp-elitedesk-800-g6-dm-core-i5-10500t-23ghz16gb-ram512gb-ssd-pcie-291315',
    p2url: 'https://www.techoutlet.eu/en/hp-elitedesk-8-mini-g1i-ultra-5-235t-16gb-ddr5-512gb-ssd-w11p-1yr-wrty-smartbuy.html',
    label1: 'computer',
    label234: 'computers',
    label5: 'computers',
    note: 'In this calculator we compare a brand-new computer with a refurbished device a few generations older. For everyday office work it still has more than enough performance.',
    co2rep: 26.2,
    co2new: 256.4,
    water: 157500,
    mat: 1318.9,
    waste: 5.413,
    specs: {
      refurb: [
        ['Processor', 'Intel Core i5-10500T 2.3 GHz'],
        ['Memory',    '16 GB DDR4'],
        ['Storage',   '512 GB SSD PCIe'],
        ['Format',    'Mini desktop'],
        ['Warranty',  '2 years']
      ],
      neww: [
        ['Processor', 'Intel Core Ultra 5 235T'],
        ['Memory',    '16 GB DDR5'],
        ['Storage',   '512 GB M.2 SSD NVMe'],
        ['Format',    'Mini desktop'],
        ['Warranty',  '2 years']
      ]
    }
  }
};

let tscalcType = 'notebook';
let tscalcMode = 'b2c';
const VAT_RATE = 1.20;

function tscalcSetMode(m, el) {
  tscalcMode = m;
  document.querySelectorAll('.tscalc-mode-btn').forEach(b => b.classList.remove('active'));
  if (el) el.classList.add('active');
  document.querySelectorAll('.tscalc-b2b-only').forEach(x => x.classList.toggle('tscalc-hidden', m !== 'b2b'));
  document.querySelectorAll('.tscalc-b2c-only').forEach(x => x.classList.toggle('tscalc-hidden', m !== 'b2c'));
  tscalcUpdate();
}

function tscalcSetDevice(t, el) {
  tscalcType = t;
  document.querySelectorAll('.tscalc-pill').forEach(b => b.classList.remove('active'));
  if (el) el.classList.add('active');

  const d = tscalcData[t];
  const set = (id, html) => { const n = document.getElementById(id); if (n) n.innerHTML = html; };
  const setText = (id, txt) => { const n = document.getElementById(id); if (n) n.textContent = txt; };

  setText('tscalc-p1name', d.p1name);
  setText('tscalc-p2name', d.p2name);
  set('tscalc-p1sub', d.p1sub);
  set('tscalc-p2sub', d.p2sub);

  const img1 = document.getElementById('tscalc-p1img');
  if (img1 && d.p1img) { img1.src = d.p1img; img1.alt = d.p1name; }
  const img2 = document.getElementById('tscalc-p2img');
  if (img2 && d.p2img) { img2.src = d.p2img; img2.alt = d.p2name; }

  tscalcUpdate();
}

function tscalcFmt(n) { return new Intl.NumberFormat('en-IE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(Math.round(n)); }
function tscalcFmtN(n) { return new Intl.NumberFormat('en-IE', { maximumFractionDigits: 0 }).format(Math.round(n)); }
function tscalcFmtDec(n) { return new Intl.NumberFormat('en-IE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n); }

function tscalcUpdate() {
  const qtyEl = document.getElementById('tscalc-qty');
  if (!qtyEl) return;
  const qty = parseInt(qtyEl.value) || 1;
  const setText = (id, txt) => { const n = document.getElementById(id); if (n) n.textContent = txt; };

  setText('tscalc-qty-out', qty + ' pcs');

  const d = tscalcData[tscalcType];
  const p1WithVat = d.p1 * VAT_RATE;
  const p2WithVat = d.p2 * VAT_RATE;

  if (tscalcMode === 'b2c') {
    setText('tscalc-p1price', tscalcFmtDec(p1WithVat));
    setText('tscalc-p1vat', tscalcFmt(d.p1) + ' excl. VAT');
    setText('tscalc-p2price', tscalcFmtDec(p2WithVat));
    setText('tscalc-p2vat', tscalcFmt(d.p2) + ' excl. VAT');
  } else {
    setText('tscalc-p1price', tscalcFmt(d.p1));
    setText('tscalc-p1vat', tscalcFmtDec(p1WithVat) + ' incl. VAT');
    setText('tscalc-p2price', tscalcFmt(d.p2));
    setText('tscalc-p2vat', tscalcFmtDec(p2WithVat) + ' incl. VAT');
  }

  const saving = (d.p2 - d.p1) * qty;
  const totalNewCost = d.p2 * qty;

  setText('tscalc-hero-qty', qty);
  const heroLabel = qty === 1 ? d.label1 : (qty >= 2 && qty <= 4) ? d.label234 : d.label5;
  setText('tscalc-hero-label', heroLabel);
  setText('tscalc-hero-vs-adj', 'new');
  setText('tscalc-hero-vs', heroLabel);
  setText('tscalc-compare-note', d.note);

  const setHref = (id, url) => { const n = document.getElementById(id); if (n) n.href = url; };
  setHref('tscalc-p1url', d.p1url);
  setHref('tscalc-p2url', d.p2url);

  const savingDisplay = (tscalcMode === 'b2c') ? saving * VAT_RATE : saving;
  setText('tscalc-hero-saving', tscalcFmt(savingDisplay));
  setText('tscalc-hero-vat-tag', (tscalcMode === 'b2c') ? 'incl. VAT' : 'excl. VAT');

  const refurbForSameMoney = Math.floor(totalNewCost / d.p1);
  setText('tscalc-same-budget', tscalcFmt(totalNewCost));
  setText('tscalc-same-new-count', qty + ' pcs');
  setText('tscalc-same-refurb-count', refurbForSameMoney + ' pcs');

  const co2saved = (d.co2new - d.co2rep) * qty;
  setText('tscalc-esg-co2', tscalcFmtN(co2saved) + ' kg');
  setText('tscalc-esg-dev', qty + ' pcs');

  const flights = Math.round(co2saved / 165);
  const kmCar = Math.round(co2saved / 0.15);
  const trees = Math.round(co2saved / 22);
  const waterSaved = d.water * qty;
  const waterPeople = Math.round(waterSaved / 48000);
  const waterPools = Math.round(waterSaved / 450000 * 10) / 10;
  const waterShowers = Math.round(waterSaved / 65);
  const matSaved = d.mat * qty;
  const cars = Math.round(matSaved / 1500 * 10) / 10;
  const wasteSaved = d.waste * qty;

  setText('tscalc-co2-val', tscalcFmtN(co2saved) + ' kg');
  const flightLabel = flights === 1 ? 'flight' : 'flights';
  setText('tscalc-co2-flights', flights + ' ' + flightLabel);
  setText('tscalc-co2-km', tscalcFmtN(kmCar) + ' km');
  setText('tscalc-co2-trees', trees + ' trees');
  setText('tscalc-water-val', tscalcFmtN(waterSaved) + ' l');
  setText('tscalc-water-people', waterPeople + ' people');
  setText('tscalc-water-pools', waterPools.toLocaleString('en-IE') + ' swimming pools');
  setText('tscalc-water-showers', tscalcFmtN(waterShowers) + ' showers');
  setText('tscalc-mat-val', tscalcFmtN(matSaved) + ' kg');
  setText('tscalc-mat-cars', cars.toLocaleString('en-IE') + ' passenger cars');
  setText('tscalc-waste-val', wasteSaved.toFixed(1) + ' kg');

  const devLabel = qty === 1 ? 'device' : 'devices';
  const verbLabel = (qty === 1) ? 'got a second life' : 'got a second life';
  setText('tscalc-waste-dev', qty + ' ' + devLabel);
  setText('tscalc-waste-verb', verbLabel);
}

const FINDER_CFG = {
  pouzitie: {
    'office':   { ram: ['8', '16'],  cpu: ['Intel Core i3', 'Intel Core i5', 'AMD Ryzen 3', 'AMD Ryzen 5'] },
    'ucto-crm': { ram: ['16', '32'], cpu: ['Intel Core 5', 'Intel Core i5', 'Intel Core i7', 'Intel Core Ultra 5', 'Intel Core Ultra 7', 'AMD Ryzen 5', 'AMD Ryzen 7'] },
    'grafika':  { ram: ['32', '64'], cpu: ['Intel Core i7', 'Intel Core i9', 'Intel Core Ultra 7', 'Intel Core Ultra 9', 'AMD Ryzen 7', 'AMD Ryzen AI 7'] },
    'vsetko':   { ram: ['16', '32'], cpu: ['Intel Core 5', 'Intel Core i5', 'Intel Core i7', 'Intel Core Ultra 5', 'Intel Core Ultra 7', 'AMD Ryzen 5', 'AMD Ryzen 7'] }
  },
  mobilita: {
    'stale-cestujem':     ['13.3', '13.5', '13.6', '14.0', '14.2'],
    'obcasne-cestovanie': ['14.0', '14.2', '15.0', '15.6'],
    'stolny-pc':          [],   // PC → no display_size, base URL switch in buildFinderUrl
    'nezalezi':           []
  },
  rozpocet: {
    'do-400':   { gte: null, lte: 400 },
    '400-700':  { gte: 400,  lte: 700 },
    '700-1200': { gte: 700,  lte: 1200 },
    'nezalezi': null
  }
};

function buildFinderUrl(pouzitie, mobilita, rozpocet) {
  const params = [];

  const price = FINDER_CFG.rozpocet[rozpocet];
  if (price) {
    if (price.gte != null) params.push('filter.v.price.gte=' + price.gte);
    if (price.lte != null) params.push('filter.v.price.lte=' + price.lte);
  }

  const useCfg = FINDER_CFG.pouzitie[pouzitie];
  if (useCfg) {
    useCfg.ram.forEach(v => params.push('filter.p.m.custom.ram_num=' + v));
    useCfg.cpu.forEach(v => params.push('filter.p.m.custom.cpu_group=' + v.replace(/ /g, '+')));
  }

  // Display size filter only makes sense for laptops; for desktop PCs we skip it.
  if (mobilita !== 'stolny-pc') {
    (FINDER_CFG.mobilita[mobilita] || []).forEach(s => {
      params.push('filter.p.m.custom.display_size=' + s + '%22');
    });
  }

  params.push('sort_by=best-selling');

  // For "I don't travel (I want a desktop)" we direct to the desktop collection — it has the same
  // filter handles (price, ram_num, cpu_group), so the parameter set works on both.
  const baseCollection = (mobilita === 'stolny-pc') ? '/collections/computers' : '/collections/laptops';
  return baseCollection + '?' + params.join('&');
}

function updateFinderSubmit() {
  const get = (q) => {
    const group = document.querySelector('.kalk-page .finder-options[data-q="' + q + '"]');
    if (!group) return null;
    const active = group.querySelector('button.active') || group.querySelector('button');
    return active ? active.getAttribute('data-value') : null;
  };
  const submit = document.getElementById('finder-submit');
  if (!submit) return;
  submit.href = buildFinderUrl(get('pouzitie'), get('mobilita'), get('rozpocet'));
}

function tscalcInit() {
  tscalcUpdate();

  document.querySelectorAll('.kalk-page .finder-options').forEach(group => {
    group.querySelectorAll('button').forEach(b => b.addEventListener('click', () => {
      group.querySelectorAll('button').forEach(x => x.classList.remove('active'));
      b.classList.add('active');
      updateFinderSubmit();
    }));
  });
  updateFinderSubmit();

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in'); });
    }, { threshold: 0.12 });
    document.querySelectorAll('.kalk-page .pain-card, .kalk-page .review, .kalk-page .tscalc, .kalk-page .tscalc-eco-a-card').forEach(el => {
      el.classList.add('reveal');
      io.observe(el);
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', tscalcInit);
} else {
  tscalcInit();
}

/* ============================================================
   PDF offer — client-side via jsPDF + autoTable
   Brand colours: --ts-primary #00b997, --ts-ink #1b102c, --ts-accent #df194f
   ============================================================ */

const TSC_PDF = {
  ink:    [27, 16, 44],
  primary:[0, 185, 151],
  paper:  [244, 248, 247],
  border: [231, 230, 233],
  accent: [223, 25, 79],
  mute:   [110, 100, 120],
  white:  [255, 255, 255]
};

let _tscalcFontsCache = null;
function tscalcLoadFonts() {
  if (_tscalcFontsCache) return _tscalcFontsCache;
  const sources = {
    normal: 'https://cdn.jsdelivr.net/gh/openmaptiles/fonts@master/roboto/Roboto-Regular.ttf',
    bold:   'https://cdn.jsdelivr.net/gh/openmaptiles/fonts@master/roboto/Roboto-Bold.ttf'
  };
  const fetchOne = (url) => fetch(url)
    .then(r => r.ok ? r.arrayBuffer() : null)
    .then(buf => {
      if (!buf) return null;
      const bytes = new Uint8Array(buf);
      let binary = '';
      const chunk = 0x8000;
      for (let i = 0; i < bytes.length; i += chunk) {
        binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunk));
      }
      return btoa(binary);
    })
    .catch(() => null);
  _tscalcFontsCache = Promise.all([fetchOne(sources.normal), fetchOne(sources.bold)])
    .then(([n, b]) => ({ normal: n, bold: b }));
  return _tscalcFontsCache;
}

function tscalcRegisterFonts(doc, fonts) {
  if (!fonts || (!fonts.normal && !fonts.bold)) return 'helvetica';
  if (fonts.normal) {
    doc.addFileToVFS('Roboto-Regular.ttf', fonts.normal);
    doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal');
  }
  if (fonts.bold) {
    doc.addFileToVFS('Roboto-Bold.ttf', fonts.bold);
    doc.addFont('Roboto-Bold.ttf', 'Roboto', 'bold');
  }
  return 'Roboto';
}

function tscalcLoadLogo() {
  const tryOne = (url) => new Promise((resolve) => {
    if (!url) { resolve(null); return; }
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        resolve({ data: canvas.toDataURL('image/png'), w: img.naturalWidth, h: img.naturalHeight });
      } catch (e) { resolve(null); }
    };
    img.onerror = function () { resolve(null); };
    img.src = url;
  });
  // Try primary (theme asset) → if it fails, try settings.logo → if that fails, return null (wordmark fallback).
  return tryOne(window.tscalcLogoUrl).then(r => r || tryOne(window.tscalcLogoFallbackUrl));
}

function tscalcShortDate() {
  const d = new Date();
  return String(d.getDate()).padStart(2, '0') + '.' +
         String(d.getMonth() + 1).padStart(2, '0') + '.' + d.getFullYear();
}

function tscalcOfferRef() {
  const d = new Date();
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const rand = Math.floor(Math.random() * 90 + 10);
  return 'TS-' + dd + mm + '-' + rand;
}

function tscalcIsoDate() {
  const d = new Date();
  return d.getFullYear() + '-' +
         String(d.getMonth() + 1).padStart(2, '0') + '-' +
         String(d.getDate()).padStart(2, '0');
}

async function tscalcDownloadPdf() {
  const btn = document.getElementById('tscalc-pdf-btn');
  const labelEl = btn ? btn.querySelector('.tscalc-pdf-label') : null;
  const originalLabel = labelEl ? labelEl.textContent : null;

  if (!window.jspdf || !window.jspdf.jsPDF) {
    if (labelEl) labelEl.textContent = 'PDF library is still loading…';
    setTimeout(() => { if (labelEl && originalLabel) labelEl.textContent = originalLabel; }, 1800);
    return;
  }

  if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
  if (labelEl) labelEl.textContent = 'Generating PDF…';

  try {
    const qtyEl = document.getElementById('tscalc-qty');
    const qty = qtyEl ? (parseInt(qtyEl.value) || 1) : 1;
    const snapshot = {
      type: tscalcType,
      mode: tscalcMode,
      qty: qty,
      data: tscalcData[tscalcType]
    };
    const [logo, fonts] = await Promise.all([tscalcLoadLogo(), tscalcLoadFonts()]);
    tscalcBuildPdf(snapshot, logo, fonts);
  } catch (err) {
    console.error('PDF generation failed:', err);
    alert('The PDF could not be generated. Please try again.');
  } finally {
    if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
    if (labelEl && originalLabel) labelEl.textContent = originalLabel;
  }
}

function tscalcDrawHeader(doc, FONT, logo, M, W) {
  doc.setFillColor(...TSC_PDF.ink);
  doc.rect(0, 0, W, 30, 'F');

  if (logo && logo.data) {
    const maxH = 14;
    const maxW = 70;
    const ratio = logo.w / logo.h;
    let targetW, targetH;
    if (maxH * ratio <= maxW) {
      targetH = maxH;
      targetW = maxH * ratio;
    } else {
      targetW = maxW;
      targetH = maxW / ratio;
    }
    const yLogo = (30 - targetH) / 2;
    try { doc.addImage(logo.data, 'PNG', M, yLogo, targetW, targetH); }
    catch (e) {
      doc.setTextColor(...TSC_PDF.white).setFont(FONT,'bold').setFontSize(18);
      doc.text('TECHSAVERS', M, 18);
    }
  } else {
    doc.setTextColor(...TSC_PDF.white).setFont(FONT,'bold').setFontSize(18);
    doc.text('TECHSAVERS', M, 18);
  }

  doc.setTextColor(...TSC_PDF.white);
  doc.setFont(FONT,'normal').setFontSize(9);
  doc.text('SAVINGS CALCULATOR', W - M, 14, { align: 'right' });
  doc.setFont(FONT,'bold').setFontSize(11);
  doc.text(tscalcShortDate(), W - M, 20, { align: 'right' });
}

function tscalcDrawFooter(doc, FONT, M, W, H, pageNum, totalPages) {
  const footY = H - 12;
  doc.setDrawColor(...TSC_PDF.border).setLineWidth(0.3);
  doc.line(M, footY - 4, W - M, footY - 4);
  doc.setFont(FONT,'bold').setTextColor(...TSC_PDF.ink).setFontSize(9);
  doc.text('www.techsavers.com  ·  info@techsavers.com', W / 2, footY, { align: 'center' });
  if (pageNum && totalPages) {
    doc.setFont(FONT,'normal').setFontSize(8).setTextColor(...TSC_PDF.mute);
    doc.text('Page ' + pageNum + ' / ' + totalPages, W - M, footY, { align: 'right' });
  }
}

function tscalcDrawSubBand(doc, FONT, M, W, segment, qtyText) {
  doc.setFillColor(...TSC_PDF.paper);
  doc.rect(0, 30, W, 14, 'F');
  doc.setTextColor(...TSC_PDF.mute).setFont(FONT,'normal').setFontSize(8);
  doc.text('FOR', M, 35);
  doc.setTextColor(...TSC_PDF.ink).setFont(FONT,'bold').setFontSize(11);
  doc.text(segment.charAt(0).toUpperCase() + segment.slice(1), M, 40);
  doc.setTextColor(...TSC_PDF.mute).setFont(FONT,'normal').setFontSize(8);
  doc.text('OFFER VOLUME', W - M, 35, { align: 'right' });
  doc.setTextColor(...TSC_PDF.ink).setFont(FONT,'bold').setFontSize(11);
  doc.text(qtyText, W - M, 40, { align: 'right' });
}

function tscalcBuildPdf(s, logo, fonts) {
  const { jsPDF } = window.jspdf;
  const doc = new jsPDF({ unit: 'mm', format: 'a4' });
  const W = 210, H = 297;
  const M = 14;
  const d = s.data;
  const FONT = tscalcRegisterFonts(doc, fonts);
  doc.setFont(FONT, 'normal');

  /* ============ PAGE 1: Header + Summary + Hero + Comparison ============ */
  tscalcDrawHeader(doc, FONT, logo, M, W);

  /* ---------- Sub-band: client + product summary ---------- */
  const segment = (s.mode === 'b2b') ? 'companies and businesses' : 'a private individual';
  const qtyLabel = (s.qty === 1) ? d.label1 : (s.qty <= 4) ? d.label234 : d.label5;
  const qtyText = s.qty + ' pcs ' + qtyLabel;
  tscalcDrawSubBand(doc, FONT, M, W, segment, qtyText);

  /* ---------- Hero — saving block ---------- */
  const saving = (d.p2 - d.p1) * s.qty;
  const savingB2C = saving * VAT_RATE;
  const heroPrimary = (s.mode === 'b2c') ? savingB2C : saving;
  const heroSecondary = (s.mode === 'b2c') ? saving : savingB2C;
  const heroPrimaryTag = (s.mode === 'b2c') ? 'incl. VAT' : 'excl. VAT';
  const heroSecondaryTag = (s.mode === 'b2c') ? 'excl. VAT' : 'incl. VAT';

  let y = 52;
  const heroH = 32;
  doc.setFillColor(...TSC_PDF.primary);
  doc.roundedRect(M, y, W - 2 * M, heroH, 3, 3, 'F');

  const heroDevLabel = (s.qty === 1) ? d.label1 : (s.qty <= 4) ? d.label234 : d.label5;
  doc.setTextColor(...TSC_PDF.white).setFont(FONT,'normal').setFontSize(9.5);
  doc.text('The amount you can save when buying ' + s.qty + ' ' + heroDevLabel, M + 8, y + 8);

  // Big number baseline and tag baseline — the tag is raised so it sits visually
  // in the middle of the height of the large digits (cap height/2 ≈ 4mm at 26pt → tag baseline 4mm higher).
  const heroNumText = tscalcFmt(heroPrimary);
  doc.setFont(FONT,'bold').setFontSize(26);
  const heroNumWidth = doc.getTextWidth(heroNumText);
  doc.text(heroNumText, M + 8, y + 22);
  doc.setFont(FONT,'normal').setFontSize(11);
  doc.text(heroPrimaryTag, M + 8 + heroNumWidth + 4, y + 18);

  doc.setFontSize(9);
  doc.text(tscalcFmtDec(heroSecondary) + ' ' + heroSecondaryTag, M + 8, y + 28);

  y += heroH + 8;

  /* ---------- B2B-only: "For the price of X you can have" comparison ---------- */
  if (s.mode === 'b2b') {
    const sameTotal = d.p2 * s.qty;
    const sameRefurb = Math.floor(sameTotal / d.p1);
    const sameH = 32;

    // Outer dark navy box
    doc.setFillColor(...TSC_PDF.ink);
    doc.roundedRect(M, y, W - 2 * M, sameH, 3, 3, 'F');

    // Title
    doc.setTextColor(...TSC_PDF.white).setFont(FONT,'normal').setFontSize(10);
    doc.text('For the price of ' + tscalcFmt(sameTotal) + ' you can have:', W / 2, y + 7, { align: 'center' });

    // Inner two cards
    const innerY = y + 11;
    const innerH = 18;
    const innerW = 65;
    const leftX = M + 12;
    const rightX = W - M - 12 - innerW;

    // Left — NEW DEVICES (muted outline)
    doc.setDrawColor(85, 75, 110).setLineWidth(0.4);
    doc.roundedRect(leftX, innerY, innerW, innerH, 2, 2, 'D');
    doc.setTextColor(190, 185, 205).setFont(FONT,'normal').setFontSize(8);
    doc.text('New devices', leftX + innerW / 2, innerY + 6, { align: 'center' });
    doc.setTextColor(...TSC_PDF.white).setFont(FONT,'bold').setFontSize(15);
    doc.text(s.qty + ' pcs', leftX + innerW / 2, innerY + 14, { align: 'center' });

    // OR label
    doc.setTextColor(...TSC_PDF.primary).setFont(FONT,'bold').setFontSize(9);
    doc.text('OR', W / 2, innerY + 11, { align: 'center' });

    // Right — REFURBISHED BY TECHSAVERS (primary highlight)
    doc.setDrawColor(...TSC_PDF.primary).setLineWidth(0.7);
    doc.roundedRect(rightX, innerY, innerW, innerH, 2, 2, 'D');
    doc.setTextColor(...TSC_PDF.primary).setFont(FONT,'bold').setFontSize(8);
    doc.text('Refurbished by Techsavers', rightX + innerW / 2, innerY + 6, { align: 'center' });
    doc.setTextColor(...TSC_PDF.white).setFont(FONT,'bold').setFontSize(15);
    doc.text(sameRefurb + ' pcs', rightX + innerW / 2, innerY + 14, { align: 'center' });

    y += sameH + 8;
  }

  /* ---------- Comparison table ---------- */
  doc.setTextColor(...TSC_PDF.ink).setFont(FONT,'bold').setFontSize(12);
  doc.text('Refurbished Techsavers vs new', M, y);
  doc.setDrawColor(...TSC_PDF.primary).setLineWidth(0.6);
  doc.line(M, y + 1.5, M + 56, y + 1.5);
  y += 6;

  const refurbTotal = d.p1 * s.qty;
  const newTotal = d.p2 * s.qty;
  const fmtUnit = (price) => (s.mode === 'b2c')
    ? tscalcFmtDec(price * VAT_RATE) + ' incl. VAT'
    : tscalcFmt(price) + ' excl. VAT';
  const fmtTotal = (total) => (s.mode === 'b2c')
    ? tscalcFmtDec(total * VAT_RATE) + ' incl. VAT'
    : tscalcFmt(total) + ' excl. VAT';

  const compareRows = [
    ['Model',         d.p1name,                             d.p2name],
    ...d.specs.refurb.map((row, i) => [row[0], row[1], (d.specs.neww[i] || ['', ''])[1]]),
    ['Price per unit', fmtUnit(d.p1),                       fmtUnit(d.p2)],
    ['Total (' + s.qty + ' pcs)', fmtTotal(refurbTotal),    fmtTotal(newTotal)]
  ];

  doc.autoTable({
    startY: y,
    head: [['', 'Techsavers', 'New']],
    body: compareRows,
    theme: 'grid',
    styles: {
      font: FONT,
      fontSize: 9,
      cellPadding: 2.5,
      lineColor: TSC_PDF.border,
      lineWidth: 0.2,
      textColor: TSC_PDF.ink
    },
    headStyles: {
      font: FONT,
      fillColor: TSC_PDF.ink,
      textColor: TSC_PDF.white,
      fontStyle: 'bold',
      fontSize: 9
    },
    alternateRowStyles: { fillColor: [250, 251, 251] },
    columnStyles: {
      0: { fontStyle: 'bold', textColor: TSC_PDF.mute, cellWidth: 36 },
      1: { textColor: TSC_PDF.ink },
      2: { textColor: TSC_PDF.mute }
    },
    didParseCell: (hook) => {
      const lastIdx = compareRows.length - 1;
      if (hook.section === 'body' && hook.row.index === lastIdx) {
        hook.cell.styles.fontStyle = 'bold';
        hook.cell.styles.fontSize = 10;
        if (hook.column.index === 1) hook.cell.styles.textColor = TSC_PDF.primary;
      }
    },
    margin: { left: M, right: M }
  });

  /* ---------- Page 1 footer ---------- */
  tscalcDrawFooter(doc, FONT, M, W, H, 1, 2);

  /* ============ PAGE 2: Header + Sub-band + ESG + Benefits + Footer ============ */
  doc.addPage();
  tscalcDrawHeader(doc, FONT, logo, M, W);
  tscalcDrawSubBand(doc, FONT, M, W, segment, qtyText);
  y = 52;

  /* ---------- B2B-only: For your sustainability goals ---------- */
  if (s.mode === 'b2b') {
    doc.setTextColor(...TSC_PDF.ink).setFont(FONT,'bold').setFontSize(12);
    doc.text('For your sustainability goals', M, y);
    doc.setDrawColor(...TSC_PDF.primary).setLineWidth(0.6);
    doc.line(M, y + 1.5, M + 60, y + 1.5);

    doc.setTextColor(...TSC_PDF.mute).setFont(FONT,'normal').setFontSize(9);
    doc.text('Sustainability is part of business today. You can use these figures with partners, in tenders or in your ESG report:', M, y + 7);
    y += 11;

    const co2Saved = (d.co2new - d.co2rep) * s.qty;
    const sustCards = [
      ['Reduced CO2 emissions',   tscalcFmtN(co2Saved) + ' kg'],
      ['Devices saved from landfill', s.qty + ' pcs'],
      ['Circular economy',        'yes']
    ];
    const sGap = 3;
    const sCardW = (W - 2 * M - 2 * sGap) / 3;
    const sCardH = 20;
    sustCards.forEach((c, i) => {
      const cx = M + i * (sCardW + sGap);
      doc.setFillColor(244, 248, 247);
      doc.setDrawColor(...TSC_PDF.border).setLineWidth(0.2);
      doc.roundedRect(cx, y, sCardW, sCardH, 2, 2, 'FD');
      doc.setTextColor(...TSC_PDF.mute).setFont(FONT,'normal').setFontSize(7.5);
      doc.text(c[0], cx + 5, y + 6);
      doc.setTextColor(...TSC_PDF.primary).setFont(FONT,'bold').setFontSize(14);
      doc.text(c[1], cx + 5, y + 15);
    });
    y += sCardH + 8;
  }

  /* ---------- ESG impact ---------- */
  {
    doc.setTextColor(...TSC_PDF.ink).setFont(FONT,'bold').setFontSize(12);
    doc.text('Environmental impact', M, y);
    doc.setDrawColor(...TSC_PDF.primary).setLineWidth(0.6);
    doc.line(M, y + 1.5, M + 32, y + 1.5);
    y += 6;

    const co2 = (d.co2new - d.co2rep) * s.qty;
    const water = d.water * s.qty;
    const mat = d.mat * s.qty;
    const waste = d.waste * s.qty;
    const flights = Math.round(co2 / 165);
    const flightLabel = (flights === 1) ? 'flight' : 'flights';
    const pools = Math.round(water / 450000 * 10) / 10;
    const cars = Math.round(mat / 1500 * 10) / 10;
    const devLabel = (s.qty === 1) ? 'device got' : 'devices got';

    const esgRows = [
      ['CO2 saved',            tscalcFmtN(co2) + ' kg',                           flights + ' ' + flightLabel + ' to London'],
      ['Water saved',          tscalcFmtN(water) + ' l',                          pools.toLocaleString('en-IE') + ' swimming pools'],
      ['Raw materials unmined', tscalcFmtN(mat) + ' kg',                          'the weight of ' + cars.toLocaleString('en-IE') + ' passenger cars'],
      ['Less e-waste',         waste.toFixed(1) + ' kg',                          s.qty + ' ' + devLabel + ' a second life']
    ];

    doc.autoTable({
      startY: y,
      body: esgRows,
      theme: 'plain',
      styles: {
        font: FONT,
        fontSize: 9.5,
        cellPadding: { top: 3, bottom: 3, left: 3, right: 3 },
        textColor: TSC_PDF.ink
      },
      columnStyles: {
        0: { fontStyle: 'bold', textColor: TSC_PDF.ink, cellWidth: 54, cellPadding: { top: 3, bottom: 3, left: 6, right: 3 } },
        1: { fontStyle: 'bold', textColor: TSC_PDF.primary, cellWidth: 34, halign: 'right' },
        2: { textColor: TSC_PDF.mute, fontSize: 9 }
      },
      didDrawCell: (hook) => {
        // Bullet point — small filled circle in primary colour before each label
        if (hook.section === 'body' && hook.column.index === 0) {
          const cy = hook.cell.y + hook.cell.height / 2;
          doc.setFillColor(...TSC_PDF.primary);
          doc.circle(hook.cell.x + 2, cy, 0.9, 'F');
        }
      },
      margin: { left: M, right: M }
    });

    y = doc.lastAutoTable.finalY + 8;
  }

  /* ---------- Why TECHSAVERS — 6 benefits in a 2×3 grid ---------- */
  doc.setTextColor(...TSC_PDF.ink).setFont(FONT,'bold').setFontSize(12);
  doc.text('Why choose Techsavers?', M, y);
  doc.setDrawColor(...TSC_PDF.primary).setLineWidth(0.6);
  doc.line(M, y + 1.5, M + 48, y + 1.5);
  y += 6;

  const benefits = (s.mode === 'b2b') ? [
    ['Invoice for your company',                'Goes straight into your costs'],
    ['Trusted by more than 25,000 companies',   'Join our satisfied businesses'],
    ['2-year warranty for businesses too',      'Full service and support during the warranty'],
    ['30-day free returns',                     'Yes, you really have nothing to lose'],
    ['Free shipping',                           'On orders over €100'],
    ['~50 % average saving',                    'Compared to buying new devices'],
    ['11-step refurbishment process',           'Every device is tested both functionally and visually'],
    ['We ship immediately',                     'Delivery within 1–2 business days']
  ] : [
    ['2-year warranty',               'Full service and support during the warranty'],
    ['30-day free returns',           'Yes, you really have nothing to lose'],
    ['Free shipping',                 'On orders over €100'],
    ['~50 % average saving',          'Compared to buying new devices'],
    ['11-step refurbishment process', 'Every device is tested both functionally and visually'],
    ['We ship immediately',           'Delivery within 1–2 business days']
  ];
  const bGap = 3;
  const bCardW = (W - 2 * M - bGap) / 2;
  const bCardH = 16;
  benefits.forEach((b, i) => {
    const col = i % 2;
    const row = Math.floor(i / 2);
    const cx = M + col * (bCardW + bGap);
    const cy = y + row * (bCardH + bGap);
    // card — light paper-warm background + subtle border
    doc.setFillColor(244, 248, 247);
    doc.setDrawColor(...TSC_PDF.border).setLineWidth(0.2);
    doc.roundedRect(cx, cy, bCardW, bCardH, 2, 2, 'FD');
    // checkmark — primary circle + white √
    const r = 3;
    const ix = cx + 5 + r;
    const iy = cy + bCardH / 2;
    doc.setFillColor(...TSC_PDF.primary);
    doc.circle(ix, iy, r, 'F');
    doc.setDrawColor(255, 255, 255).setLineWidth(0.7);
    doc.line(ix - 1.4, iy + 0.1, ix - 0.3, iy + 1.2);
    doc.line(ix - 0.3, iy + 1.2, ix + 1.5, iy - 0.9);
    // title + subtitle
    const tx = cx + 5 + 2 * r + 4;
    doc.setTextColor(...TSC_PDF.ink).setFont(FONT,'bold').setFontSize(9.5);
    doc.text(b[0], tx, cy + 6.5);
    doc.setTextColor(...TSC_PDF.mute).setFont(FONT,'normal').setFontSize(7.8);
    doc.text(b[1], tx, cy + 11.5);
  });
  const bRows = Math.ceil(benefits.length / 2);
  y += bRows * bCardH + (bRows - 1) * bGap;

  /* ---------- Page 2 footer ---------- */
  tscalcDrawFooter(doc, FONT, M, W, H, 2, 2);

  /* ---------- Save ---------- */
  const filename = 'techsavers-offer-' + s.type + '-' + s.qty + 'pcs-' + tscalcIsoDate() + '.pdf';
  const inIframe = (function () { try { return window.self !== window.top; } catch (e) { return true; } })();
  if (inIframe) {
    // The Shopify theme editor and similar sandboxed iframes do not allow an <a download> click —
    // we open the PDF in a new tab (outside the sandbox), where the user can download it natively.
    const blob = doc.output('blob');
    const url = URL.createObjectURL(blob);
    const win = window.open(url, '_blank');
    if (!win) {
      // popup blocker → fallback to a direct data URL link
      doc.save(filename);
    }
  } else {
    doc.save(filename);
  }
}
